'use strict'

import * as BasUtil from '@basalte/bas-util'

angular
  .module('basalteApp')
  .controller('notificationModalCtrl', [
    '$rootScope',
    '$scope',
    'BAS_SPLASH',
    'title',
    'body',
    'close',
    notificationModalCtrl
  ])

/**
 * @param $rootScope
 * @param $scope
 * @param {BAS_SPLASH} BAS_SPLASH
 * @param {string} title
 * @param {string} body
 * @param close
 */
function notificationModalCtrl (
  $rootScope,
  $scope,
  BAS_SPLASH,
  title,
  body,
  close
) {
  var modal = this

  var _listeners = []

  modal.title = title
  modal.body = body

  modal.close = close

  init()

  function init () {

    _listeners.push($rootScope.$on(
      BAS_SPLASH.EVT_SPLASH_VISIBILITY_CHANGED,
      _onSplashVisibility
    ))

    $scope.$on('$destroy', _onDestroy)
  }

  function _onSplashVisibility () {

    close()
  }

  function _onDestroy () {

    BasUtil.executeArray(_listeners)
    _listeners = []
  }
}
